module.exports = __webpack_public_path__ + "img/iurisprudentiaW.6220ee04.png";